import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getPortfolioNewsDetail } from 'src/app/home/adapters'
import { mapPortfolioNewsDetail } from 'src/app/home/pages/portfolio-news/domain/use-cases/map-portfolio-news-detail'
import type { IPortfolioNewsArticleEntity } from 'src/app/home/pages/portfolio-news/types'
import { portfolioNewsKeys } from 'src/app/home/queries/keys'

export const usePortfolioNewsDetailQuery = (
  articleId: string | undefined,
): UseQueryResult<IPortfolioNewsArticleEntity, Error> => {
  return useQuery({
    queryKey: portfolioNewsKeys.detail(articleId ?? ''),
    queryFn: async (): Promise<IPortfolioNewsArticleEntity> => {
      if (articleId === undefined) {
        throw new Error('usePortfolioNewsDetailQuery: articleId is required')
      }
      const dto = await getPortfolioNewsDetail(articleId)
      return mapPortfolioNewsDetail(dto)
    },
    enabled: !!articleId,
  })
}
